module.exports = __webpack_public_path__ + "static/media/cloud-storage.dd1017ed.svg";